import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/walk"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4197 2.75C10.4197 3.7165 9.63619 4.5 8.66969 4.5C8.47265 4.5 8.28322 4.46744 8.10648 4.40739L8.51455 4.65224L10.8561 6.05717L12.6149 5.17776L13.5094 6.96661L11.2595 8.09152L10.7685 8.33702L10.2978 8.05459L8.64104 7.06051L6.72042 14.7514L4.78001 14.2669L6.39357 7.80552L7.1572 4.83403L7.51441 4.63558L7.99847 4.36665C7.36508 4.10338 6.91969 3.4787 6.91969 2.75C6.91969 1.7835 7.70319 1 8.66969 1C9.63619 1 10.4197 1.7835 10.4197 2.75ZM5.9273 5.51731L2.45233 7.44784L3.42362 9.19616L5.24142 8.18627L5.9273 5.51731ZM8.4586 11.6207L8.42573 11.573L9.09629 9.02056L10.1614 10.5671L10.217 10.6479L10.2559 10.7379L11.7129 14.1127L9.87672 14.9054L8.4586 11.6207Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Walk16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Walk16 = createIcon(IconComponent);